import React from "react";
import dumyimage from "../../assets/dumyimage.png";

function Image({ className = "", src, alt }) {
  return (
    <div className="h-auto">
      {src ? (
        <>
          <img
            className={`w-10 h-10 rounded-full max-w-xs ${className}`}
            src={src}
            alt={alt}
          />
        </>
      ) : (
        <>
          <img
            className={`w-10 h-10 rounded-full max-w-xs ${className}`}
            src={dumyimage}
            alt={alt}
          />
        </>
      )}
    </div>
  );
}

export default Image;
